import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCaretDown,
  faDownload,
  faClone
} from '@fortawesome/free-solid-svg-icons'
import Form from 'react-bootstrap/Form'
import PropTypes from 'prop-types'
import FieldLabel from 'shared/forms/field-label'
import { useCreateExport } from 'api/hooks/use-exports'
import { useEffect } from 'react'
import { toast } from 'react-toastify'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import { pickPresentParams, prepParams } from 'helpers/utils'

export default function DownloadTransactions({
  defaultName = 'Export',
  source = '',
  queryParams,
  onDuplicate
}) {
  const [name, setName] = useState(defaultName)
  const [show, setShow] = useState(false)
  const presentParams = pickPresentParams(prepParams(queryParams))

  const exportParams = {
    name: name,
    source: source,
    status: 'queued',
    params: presentParams
  }
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const { mutate, isSuccess } = useCreateExport({
    params: exportParams
  })

  useEffect(() => {
    if (isSuccess) {
      handleClose()
      setName(defaultName)
      toast.success('File will be available in Exports shortly')
    }
  }, [defaultName, isSuccess])

  return (
    // <Button  onClick={handleShow} size='sm'>
    <React.Fragment>
      <DropdownButton
        className="text-dark outline-dark bg-light me-2 float-end"
        variant="light"
        id="dropdown-basic-button"
        placement="bottom-start"
        size="sm"
        title={
          <span>
            Actions <FontAwesomeIcon icon={faCaretDown} />
          </span>
        }
      >
        <Dropdown.Item as={Button} onClick={handleShow}>
          <span className="text-primary">
            <FontAwesomeIcon icon={faDownload} className="me-1" /> Export
          </span>
        </Dropdown.Item>
        {onDuplicate && (
          <Dropdown.Item as={Button} onClick={onDuplicate} title="Duplicate">
            <span className="text-primary">
              <FontAwesomeIcon icon={faClone} className="me-1" /> Duplicate
            </span>
          </Dropdown.Item>
        )}
      </DropdownButton>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="lead fw-normal">
            <FontAwesomeIcon icon={faDownload} className="text-muted mx-2" />
            Export
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <FieldLabel>Export Name</FieldLabel>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            className="bg-white text-muted"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button variant="primary" onClick={() => mutate()}>
            Export
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}

DownloadTransactions.propTypes = {
  defaultName: PropTypes.string,
  source: PropTypes.string,
  queryParams: PropTypes.object,
  onDuplicate: PropTypes.func
}
